import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthToken } from 'src/app/models/authToken';
import { MessageService } from 'src/app/services/message.service';
import { AdminService } from '../admin.service';

@Component({
  selector: 'oap-home-admin',
  templateUrl: './home-admin.component.html',
  styleUrls: ['./home-admin.component.scss']
})

export class HomeAdminComponent implements OnInit {

  navLinks: any[];
  activeLinkIndex = -1; 

  showScheduler = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private adminService: AdminService) {
      
    this.navLinks = [
        {
          label: 'Gestion Utilisateurs StallergenesGreer',
          link: 'manage-users',
          index: 0
        }, {
          label: 'Gestion des comptes patients',
          link: 'locked-users',
          index: 0
        }, {
          label: 'Requêtes prédéfinies',
          link: 'predefined-queries',
          index: 1
        }, {
          label: 'Support Sujets',
          link: 'home-support-sujet',
          index: 2
      }
    ];
  }

  ngOnInit(): void {

    this.messageService.sendMessage('page-admin');
    let authToken: AuthToken = JSON.parse(localStorage.getItem('currentUser'));

    if (authToken.type === "A") {
        this.adminService.getAdminByCptKey(authToken.id).subscribe(
          response => {
            let serverResponse = response.body;
            if (serverResponse.login == 'Horace') {

              this.navLinks.push({
                label: 'Planificateur de tâche',
                link: 'scheduler',
                index: 3
              });  
              
              this.showScheduler = true;
            }
          },
          err => {
            console.log(err);
          });
    }

    this.router.events.subscribe((res) => {
        this.activeLinkIndex = this.navLinks.indexOf(this.navLinks.find(tab => tab.link === '.' + this.router.url));
    });

    this.router.navigate([this.navLinks[0].link], 
      {
          relativeTo:this.route, 
          queryParams: { typeSupportSujet: this.navLinks[0].typeSupportSujet }
      });

  }

}
